module.exports = __webpack_public_path__ + "img/top_slider_vitamin-d.46bbc86c.jpg";